import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
} from "@material-ui/core";
import { Select } from "@ofqual/portal-components/components/Select";

import { useState } from "react";
import { useDispatch } from "react-redux";
import { RecipientsViewModel } from "../../../../domain/RecipientsViewModel";
import { useGetTeamsAndUsers } from "../../../../hooks/useGetTeamsAndUsers";
import { assignUsers } from "../../../../redux/actions";

const useStyles = makeStyles((theme) => ({
  actions: {
    padding: 15,
    justifyContent: "space-between",
  },
  actionsLeft: {},
}));

type AssignUserDialogDialogProps = {
  onClose: () => void;
  recipients: RecipientsViewModel;
};

export const AssignUserDialog: React.FC<AssignUserDialogDialogProps> = ({
  onClose,
  recipients,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { userLookups, teamLookups } = useGetTeamsAndUsers();

  const [selectedTeam, setSelectedTeam] = useState<string | undefined>(
    undefined
  );

  const [selectedUser, setSelectedUser] = useState<string | undefined>(
    undefined
  );

  const handleSelect = () => {
    if (selectedUser) {
      const fullSelectedUser = userLookups.find(
        (user) => user.id === selectedUser
      );
      const assignUsersArgs = recipients.orgs
        .filter((org) => org.isSelected)
        .map((org) => ({
          organisationId: org.id,
          upn: selectedUser,
          displayName: fullSelectedUser?.label || selectedUser,
        }));
      dispatch(assignUsers(recipients.id, assignUsersArgs));
    }
    onClose();
  };

  const handleUnassign = () => {
    const assignUsersArgs = recipients.orgs
      .filter((org) => org.isSelected)
      .map((org) => ({ organisationId: org.id, upn: null, displayName: null }));
    dispatch(assignUsers(recipients.id, assignUsersArgs));

    onClose();
  };

  const handleSetSelectedTeam = (teamId: string) => {
    setSelectedTeam(teamId);
    setSelectedUser(undefined);
  };

  const handleSetSelectedUser = (userId: string) => {
    setSelectedUser(userId);
  };

  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Add staff permission - select a team and user</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Select
              label="Select team"
              value={selectedTeam}
              onChange={(val) => handleSetSelectedTeam(val.target.value)}
              fullWidth
              datatest="assign-select-team-field"
            >
              {teamLookups}
            </Select>
          </Grid>
          <Grid item xs={12}>
            <Select
              label={
                selectedTeam === undefined
                  ? "Please Select a team first"
                  : "Select a user"
              }
              value={selectedUser}
              onChange={(val) => handleSetSelectedUser(val.target.value)}
              fullWidth
              disabled={!selectedTeam}
              datatest="assign-select-user-field"
            >
              {[
                ...userLookups.filter((user) =>
                  user.teams.some((team) => team.id === selectedTeam)
                ),
              ]}
            </Select>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          component="button"
          color="primary"
          onClick={handleUnassign}
          className={classes.actionsLeft}
          data-test="unassign-button"
        >
          Unassign
        </Button>
        <Button
          component="button"
          color="primary"
          onClick={handleSelect}
          data-test="assign-dialog-confirm-button"
        >
          Select
        </Button>
      </DialogActions>
    </Dialog>
  );
};
